<!-- Toast.vue -->
<template>
  <div v-if="visible" class="toast" :class="toastType">
    {{ message }}
  </div>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        message: '',
        toastType: '', // 默认的 toastType
        timeout: null
      };
    },
    methods: {
      showToast(message, duration = 3000, type = '') {
        this.message = message;
        this.toastType = type; // 设置 toast 类型（可选）
        this.visible = true;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.visible = false;
        }, duration);
      }
    }
  };
</script>

<style scoped>
  .toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 9999;
    opacity: 0.9;
  }

  /* 例如，定义一些不同类型的 Toast 样式 */
  .success {
    background-color: green;
  }

  .error {
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/toast.vue